import { PLAYGROUND_SYM } from "./playground";
import { PLAYGROUND_ORIGIN } from "./request";
function pythonLiteral(value: unknown, depth = 0): string {
  const indent = "    ".repeat(depth);
  const childIndent = indent + "    ";
  if (value === null) return "None";
  if (typeof value === "boolean") return value ? "True" : "False";
  if (Array.isArray(value))
    return value.length
      ? `[\n${value.map((child) => childIndent + pythonLiteral(child, depth + 1)).join(",\n")}\n${indent}]`
      : "[]";
  if (typeof value === "object") {
    const entries = Object.entries(value!);
    return entries.length
      ? `{\n${entries.map(([key, child]) => `${childIndent}${JSON.stringify(key)}: ${pythonLiteral(child, depth + 1)}`).join(",\n")}\n${indent}}`
      : "{}";
  }
  return JSON.stringify(value);
}

export function requestExamples({
  method,
  server,
  path,
  example,
  requiresAuth,
}: {
  method: string;
  server: string;
  path: string;
  example: string;
  requiresAuth: boolean;
}) {
  const url = new URL(server);
  if (url.origin === PLAYGROUND_ORIGIN)
    path = path.replaceAll("{sym}", PLAYGROUND_SYM);
  const endpoint = server.replace(/\/$/, "") + path;
  const body = method === "GET" || method === "HEAD" ? "" : example;
  const headers = {
    Accept: "application/json",
    ...(requiresAuth ? { Authorization: "Bearer YOUR_JWT" } : {}),
    ...(body ? { "Content-Type": "application/json" } : {}),
  };
  const quote = (value: string) => `'${value.replace(/'/g, `'\\''`)}'`;
  return {
    HTTP: `${method} ${url.pathname.replace(/\/$/, "")}${path} HTTP/1.1\nHost: ${url.host}\n${Object.entries(
      headers,
    )
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n")}${body ? `\n\n${body}` : ""}`,
    cURL: [
      `curl --request ${method}`,
      `  --url ${quote(endpoint)}`,
      ...Object.entries(headers).map(
        ([key, value]) => `  --header ${quote(`${key}: ${value}`)}`,
      ),
      ...(body ? [`  --data ${quote(body)}`] : []),
    ].join(" \\\n"),
    JavaScript: `${body ? `const payload = ${JSON.stringify(JSON.parse(body), null, 2)};\n\n` : ""}const response = await fetch(${JSON.stringify(endpoint)}, {\n  method: ${JSON.stringify(method)},\n  headers: ${JSON.stringify(headers, null, 2).replace(/\n/g, "\n  ")},\n${body ? "  body: JSON.stringify(payload),\n" : ""}});\n\nconst data = await response.json();\nconsole.log(data);`,
    Python: `import requests\n\n${body ? `payload = ${pythonLiteral(JSON.parse(body))}\n\n` : ""}response = requests.request(\n    ${JSON.stringify(method)},\n    ${JSON.stringify(endpoint)},\n    headers=${pythonLiteral(headers, 1)},\n${body ? "    json=payload,\n" : ""}    timeout=30,\n)\nresponse.raise_for_status()\nprint(response.json())`,
  };
}
